import * as React from 'react';
export const IcSteps = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.5 2C4.57 2 3 4.69 3 8a8.36 8.36 0 001.17 4.46 45.348 45.348 0 015-.68A8.9 8.9 0 0010 8c0-3.31-1.57-6-3.5-6zM5.33 14.29A4.49 4.49 0 005 16c0 1.93 1.12 4 2.5 4s2.5-2.07 2.5-4a4.42 4.42 0 00-.57-2.21c-1.58.12-2.97.31-4.1.5zM17.5 4C15.57 4 14 6.69 14 10a8.93 8.93 0 00.77 3.74c1.708.104 3.406.335 5.08.69A8.37 8.37 0 0021 10c0-3.31-1.57-6-3.5-6zm-2.9 11.74A4.36 4.36 0 0014 18c0 1.93 1.12 4 2.5 4s2.5-2.07 2.5-4a4.37 4.37 0 00-.36-1.77 34.199 34.199 0 00-4.04-.49z'
      fill='currentColor'
    />
  </svg>
);
